import { ListPlaceholder } from "components/placeholders/ListItemPlaceholder";
import { RouteLink } from "Routes";
import { PresetCollectionDto } from "dtos/frankenstories/prompts/PresetCollectionDto";
import { NavLink } from "react-router-dom";

export const PromptCollectionDisplay = (props: { collections?: Array<PresetCollectionDto> }) => {
    const { collections } = props;

    return collections == null ? (
        <ListPlaceholder />
    ) : (
        <div className="vstack gap-4 gap-lg-5 mx-auto" style={{ maxWidth: 350 }}>
            {collections.map(collection => (
                <div key={collection.id} className="vstack gap-4 gap-lg-5">
                    <div className="vstack gap-4 gap-lg-5">
                        {collection.programs.map(program => (
                            <div key={program.id}>
                                <div className="vstack gap-3">
                                    <div className="h5">{program.name}</div>

                                    <ul className="mb-0">
                                        {program.topics.map(t => (
                                            <li key={t.id}>
                                                <div className="hstack gap-2">
                                                    <NavLink
                                                        to={RouteLink.promptsTopic(t.friendlyUrl)}
                                                        className="link-white mb-1 d-inline-block small"
                                                    >
                                                        {t.name}
                                                    </NavLink>

                                                    <span className="small">({t.presetCount})</span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};
